import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

import mgkHeroImage from "../../../assets/images/mgk/mgk_hero.webp";
import { MGK_SUBTITLE, MGK_TITLE } from "../mgkContent";

/**
 * MGK のヒーロー。/careers・/about と同じ構成（din-2014 の英語大見出し +
 * AXIS L・字間 0.3em の日本語サブタイトル）。写真が暗いので文字は白。
 */
const HeroSection = styled(motion.section)`
  position: relative;
  width: 100%;
  height: 100dvh;
  overflow: hidden;

  background-color: #1a1611;
  background-image: url(${mgkHeroImage});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`;

const HeroTagline = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const MainTitle = styled(motion.h1)`
  font-family: "din-2014-rounded-variable", sans-serif;
  font-variation-settings: "wght" 200;
  font-style: normal;

  font-size: clamp(3rem, 2.273rem + 3.64vw, 7rem);
  line-height: 100%;
  letter-spacing: 0.05em;

  color: #fff;
`;

const SubTitle = styled(motion.p)`
  font-family: "A+mfCv-AXISラウンド 50 L StdN", "M PLUS 1p", sans-serif;
  font-weight: normal;

  font-size: clamp(1rem, 0.8rem + 1vw, 1.5rem);
  line-height: 150%;
  letter-spacing: 0.3em;

  color: #fff;
`;

const MgkHero: React.FC = () => {
  return (
    <HeroSection
      initial={{ opacity: 0, scale: 1.1 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.5 }}
    >
      <HeroTagline>
        <MainTitle
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          {MGK_TITLE}
        </MainTitle>
        <SubTitle
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          {MGK_SUBTITLE}
        </SubTitle>
      </HeroTagline>
    </HeroSection>
  );
};

export default MgkHero;
